// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"x8-z"};